import { ReactNode, Suspense } from 'react';
import { Provider } from 'react-redux';
import { store } from '@/store/index';
import { MantineProvider } from './MantineProvider';
import { QueryProvider } from './QueryProvider';
import { ContentProvider } from './ContentProvider';
import { DatesProvider } from './DatesProvider';
import { Loading } from '@/components/ui/loading/Loading';

import { PartnerProvider } from './PartnerProvider';

export const AppProviders = ({ children }: { children: ReactNode }) => {
	return (
		<Provider store={store}>
			<QueryProvider>
				<ContentProvider>
					<PartnerProvider>
						<MantineProvider>
							<DatesProvider>
								<Suspense fallback={<Loading />}>{children}</Suspense>
							</DatesProvider>
						</MantineProvider>
					</PartnerProvider>
				</ContentProvider>
			</QueryProvider>
		</Provider>
	);
};
